import React, { Component } from 'react';
import firebase from '../firebase';
import Header from './Header';
import Cart from './Cart';
import Product from './Product';
import Detail from './Detail';
import Footer from './Footer';
import '../App.css';

class App extends Component {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			inventory: [],
			cart: [],
			total: 0,
			cartShown: false,
			detailShown: false,
			detail: ''
		};
	}
	componentDidMount() {
		const dbRef = firebase.database().ref();
		dbRef.on('value', response => {
			const products = response.val();

			const cart = [];
			const inventory = [];

			//a giant object of inventory, each key reprensents the index of a product while the value resprent the product object
			//loop through object keys, push each value (an object) as an object into inventory array
			for (let product in products) {
				inventory.push(products[product]);
				// push equal number of 0s into cart array to start with an empty cart
				cart.push(0);
			}
			this.setState({
				inventory: inventory,
				cart: cart,
				isLoading: false
			});
		});
	}

	//method to handle button.add click event
	//id (of item being clicked on) is passed from Product Component
	add = id => {
		const newCart = this.state.cart;
		//use the item id as index to access the value in this.state.cart array
		newCart[id]++;
		this.calcTotal();
	};

	//method to handle button.remove click event
	remove = id => {
		const newCart = this.state.cart;
		newCart[id]--;

		this.setState({
			cart: newCart
		});
		this.calcTotal();
	};

	//calculate total amount due when cart updates
	calcTotal = () => {
		let newTotal = 0;
		const items = this.state.inventory;

		items.forEach(item => {
			// use item.id as index to access value in cart array (quantity currently in cart)
			newTotal =
				//round to 2 decimals
				Math.round((newTotal + item.price * this.state.cart[item.id]) * 100) /
				100;
		});
		this.setState({ total: newTotal });
	};

	// based on the item clicked, access item detail and set state
	setDetail = id => {
		const newDetail = this.state.inventory[id].description;
		this.setState({ detail: newDetail });
		this.toggleDetail();
	};
	//toggle if detail modal box is currently visible
	toggleDetail = () => {
		const newDetailState = !this.state.detailShown;
		this.setState({ detailShown: newDetailState });
	};

	//toggle if cart modal box is currently visible
	toggleCart = () => {
		const newCartState = !this.state.cartShown;
		this.setState({ cartShown: newCartState });
	};

	//when checkout button is clicked, update Firebase database, empty cart and reset total
	checkout = () => {
		this.state.cart.forEach((quantity, index) => {
			firebase
				.database()
				.ref(`/${index}/stock`)
				.set(this.state.inventory[index].stock - quantity);
		});
		const emptyCart = [];
		this.state.inventory.forEach(() => {
			emptyCart.push(0);
		});
		this.setState({ cart: emptyCart, total: 0 });
	};

	render() {
		return (
			<div className='app'>
				<Header showCart={this.toggleCart} />
				<Cart
					total={this.state.total}
					cart={this.state.cart}
					products={this.state.inventory}
					checkout={this.checkout}
					cartShown={this.state.cartShown}
					hideCart={this.toggleCart}
				/>

				<Product
					inventory={this.state.inventory}
					add={this.add}
					remove={this.remove}
					cart={this.state.cart}
					isLoading={this.state.isLoading}
					setDetail={this.setDetail}
				/>

				<Detail
					detailShown={this.state.detailShown}
					detail={this.state.detail}
					toggleDetail={this.toggleDetail}
				/>
				<Footer />
			</div>
		);
	}
}

export default App;
